var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ImageInput',{attrs:{"suggest":"alphabet","aspect-ratio":1},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }